module.exports = __webpack_public_path__ + "img/label.d2750c43.png";